import React from 'react';
import {Col, DatePicker} from 'antd';
import dayjs from 'dayjs';
import {useFormikContext} from 'formik';
import FieldError from '../FieldError';
import FieldLabel from '../FieldLabel';
import {getDisabledDate} from '../dateHelpers';
import {fieldColProps} from '../gridHelpers';

// MUI's DatePicker took a `views` array (e.g. ['year','month']); antd's
// DatePicker instead takes a single `picker` mode. Best-effort mapping —
// coarsest granularity present in `views` wins.
const pickerFromViews = (views?: string[]): 'date' | 'month' | 'year' => {
  if (!views || views.includes('day')) return 'date';
  if (views.includes('month')) return 'month';
  if (views.includes('year')) return 'year';
  return 'date';
};

export default function DatePickerBox(props) {
  const textField = props.field;
  const {setFieldValue, setFieldTouched, values, touched, errors} = useFormikContext<any>();
  const hasError = Boolean(touched[textField?.name] && errors[textField?.name]);

  return (
    <Col {...fieldColProps(textField)}>
      <FieldLabel field={textField} />
      <DatePicker
        picker={pickerFromViews(textField.views)}
        placeholder={textField?.format}
        format={textField?.format}
        style={{width: '100%'}}
        status={hasError ? 'error' : undefined}
        disabled={textField.isDisabled ?? false}
        disabledDate={getDisabledDate(textField)}
        value={values[textField?.name] ? dayjs(values[textField?.name]) : null}
        onChange={(value) => {
          setFieldValue(textField.name, value ? value.toDate() : null);
          setFieldTouched(textField.name, true, false);
        }}
      />
      <FieldError name={textField.name} />
    </Col>
  );
}
